module.exports = __webpack_public_path__ + "static/img/top-one-bg.300672f3.png";